const configAttr = {
  lineRectStrokeColorPurple: {
    stroke: "#cc99ff",
    "stroke-dasharray": "5,5",
  },
  dash_rect: {
    stroke: "#ADD8E6",
    "stroke-dasharray": "5,5",
  },
  dash_rectLight: {
    stroke: "#04112F",
    "stroke-dasharray": "5,5",
  },
  dash_disable_rect: {
    stroke: "#9E9E9E",
    "stroke-dasharray": "5,5",
  },
  dash_disable_rectLight: {
    stroke: "#808080",
    "stroke-dasharray": "5,5",
  },
  dash_disable_rect_orange: {
    stroke: "#ff9900",
    "stroke-dasharray": "5,5",
  },
};
export default configAttr;
